import { createFileRoute } from '@tanstack/react-router'
import { AdminAiSpend } from '../features/admin'
import { adminRouteState } from '../features/admin/route-state'

export const Route = createFileRoute('/admin/ai-spend')({
  ...adminRouteState,
  component: AdminAiSpend,
})
